export default "__VITE_ASSET__DYkyU3U3__"